<script lang="ts">
	import { page } from '$app/stores';
	import { getAuth } from 'firebase/auth';
	import posthog from 'posthog-js';

	import authStore from '../stores/auth';
	import MenuButton from './MenuButton.svelte';
	import ZonnedakjeLogo from './ZonnedakjeLogo.svelte';

	let loggedIn = false;
	authStore.subscribe(async ({ isLoggedIn, firebaseControlled }) => {
		if (!isLoggedIn && firebaseControlled) {
			loggedIn = false;
		} else if (isLoggedIn && firebaseControlled) {
			loggedIn = true;
		}
	});

	async function logout() {
		try {
			const auth = getAuth();
			await auth.signOut();
			posthog.reset();
		} catch (error) {
			// Handle login error
			console.error('Logout failed:', error);
		}
	}

	let logoIsVisible = false;
	$: updateLogoVisibilty($page.route.id);

	function updateLogoVisibilty(routeId: string | null) {
		if (!routeId) {
			logoIsVisible = true;
			return;
		}
		if (routeId === '/(standard)') {
			logoIsVisible = window.scrollY >= 200;
		} else {
			logoIsVisible = true;
		}
	}

	function onWindowScroll() {
		updateLogoVisibilty($page.route.id);
	}
</script>

<svelte:window on:scroll={onWindowScroll} />

<nav class="top-bar surface">
	<div class="left-items">
		<MenuButton />
		<img
			class="icon"
			class:visible={!logoIsVisible}
			src="/img/zonnedakje_icon.svg"
			alt="Zonnedakje icon"
		/>
	</div>
	{#if logoIsVisible}
		<div class="logo-container">
			<ZonnedakjeLogo
				textColor="#00007e"
				textColorDark="#fff"
				arcColor="#ff5f10"
				arcColorDark="#fff"
				width={160}
			/>
		</div>
	{/if}
	{#if !loggedIn}
		<div class="icon-btn" aria-label="Logout immediately">
			<span
				on:click={logout}
				on:keydown={logout}
				class="material-symbols-rounded icon on-surface-text">logout</span
			>
		</div>
	{:else}
		<a href="/login" class="icon-btn" aria-label="navigeer naar login">
			<span class="material-symbols-rounded icon on-surface-text">account_circle</span>
		</a>
	{/if}
</nav>

<style>
	nav {
		position: fixed;
		width: 100%;
		max-width: 100%;
		height: 3.5rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 0.5em;
		z-index: 10;
	}

	.left-items {
		display: flex;
		position: relative;
		gap: 8px;
	}

	@media (min-width: 768px) {
		nav {
			display: none;
		}
	}

	.icon {
		position: absolute;
		left: 100%;
		opacity: 0;
		top: 50%;
		transform: translateY(-50%);
		transition: opacity 0.3s ease;
	}

	.visible {
		opacity: 1;
	}

	a {
		text-decoration: none;
	}

	.logo-container {
		animation: fade 0.5s ease-in-out;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
	@keyframes fade {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>
